import React from 'react';
const frictions = ['Non hai materiale professionale pronto per una lezione, workshop o attività.', 'I volantini istituzionali freddi non generano connessione emotiva.', 'Le lezioni teoriche senza dinamiche pratiche non aprono il dialogo.'];
export function Problem() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-117" data-mp="2geaw0iwf5gi5">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-118" data-mp="2gczjnuowr0ff">
        <p className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-amber-700" data-id="element-119" data-mp="21p4psaz5yq0r">
          Il Problema Reale
        </p>
        <h2 className="mt-4 font-display text-[2rem] font-extrabold leading-[1.1] tracking-tight text-night md:text-5xl" data-id="element-120" data-mp="1sp85eljt4dbi">
          Hai l’intenzione.{' '}
          <span className="bg-amber-400 px-1.5 pb-0.5 text-night" data-id="element-121" data-mp="1wrmkqvo9ouy1">Non hai il materiale.</span>
        </h2>

        <ul className="mt-11 space-y-4 text-left" data-id="element-122" data-mp="1irk8pq2n4vqp">
          {frictions.map(item => <li key={item} className="flex items-start gap-4 border-l-4 border-amber-300 bg-canvas px-5 py-4 text-lg text-gray-700 md:px-6 md:text-xl" data-id="element-123" data-mp="1noty55q157ej">
              {item}
            </li>)}
        </ul>

        <p className="mt-11 font-display text-2xl font-extrabold leading-snug tracking-tight text-night md:text-3xl" data-id="element-124" data-mp="12ad42aeqj552">
          Il tempo scade. I costi aumentano. E il silenzio rimane il nemico.
        </p>
      </div>
    </section>;
}